import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { EMAIL_REGEX } from '@monofront/business/constants';
import { useMutation } from '@apollo/client';
import { dataLayerTrackEvent } from '@utils/tracking';
import { computeTrackingPageType } from '@monofront/business/utils';
import { trackEvent } from '@monofront/tracking';
import { useRouter } from 'next/router';
import { SUBSCRIBE_TO_OFFER_NEWSLETTER } from '@monofront/business/queries';
import logger from '@utils/logger';
import { useTranslations } from 'next-intl';
import { TextInputAction } from '@monofront/design-system/components/FormV2';
import { useEffect } from 'react';
import {
  Input,
  Button,
} from '@monofront/design-system/components/FormV2/TextInputAction';

const Newsletter = ({ slice }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    formState: {
      dirtyFields,
      touchedFields,
      isSubmitted,
      isValid,
      submitCount,
    },
    getValues,
  } = useForm({
    mode: 'onSubmit',
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });
  const router = useRouter();
  const isValidEmail =
    (Boolean(getValues().email) || 'email' in dirtyFields) && !errors.email;

  const tGlobal = useTranslations('Global');
  const tAccount = useTranslations('Account');

  const handleAddToNewsletterSuccess = () => {
    toast(tAccount('newsletterSubscribed'));

    // deprecated tracker https://gitlab.com/la-fourche/scrum/-/issues/1968
    dataLayerTrackEvent('subscribedToNewsletter', {
      pageType: computeTrackingPageType(router.asPath),
    });

    trackEvent({ type: 'LFSubscribeToNewsletter' });
  };

  const [addToNewsletter] = useMutation(SUBSCRIBE_TO_OFFER_NEWSLETTER);

  const handleAddToNewsletterApiCall = async (email) => {
    if (errors.email?.message) {
      toast(tAccount('useValidEmail'), {
        progressClassName: 'toast-error',
      });

      return;
    }

    try {
      await addToNewsletter({
        variables: {
          email,
        },
      });
      handleAddToNewsletterSuccess();
    } catch (e: any) {
      logger.error('Error during newsletter subscription', { error: e });
    }
  };

  const handleAddToNewsletter = async ({
    email,
  }: Record<string, any>): Promise<any> => {
    return await handleAddToNewsletterApiCall(email);
  };

  useEffect(() => {
    if (isSubmitted && !isValid) {
      toast(tAccount('useValidEmail'), {
        progressClassName: 'toast-error',
      });
    }
  }, [submitCount]);

  return (
    <div>
      <p>{slice.primary.label}</p>
      <form onSubmit={handleSubmit(handleAddToNewsletter)}>
        <TextInputAction
          id="email"
          isValid={isValidEmail}
          isInvalid={touchedFields?.email && errors.email}
          UNSAFE_className="tw-w-full"
        >
          <Input
            {...register('email', {
              required: true,
              pattern: {
                value: EMAIL_REGEX,
                message: tAccount('useValidEmail'),
              },
            })}
            placeholder={tAccount('yourEmail')}
          />
          <Button>{tGlobal('ok')}</Button>
        </TextInputAction>
      </form>
    </div>
  );
};

export default Newsletter;
